import { z } from 'zod';

export const embeddedCustomOauthFormSchema = z.object({
  clientId: z.string(),
  authorizeUrl: z.string().url(),
  accessUrl: z.string().url(),
  clientSecret: z.string(),
  jwksEndpointUrl: z.string().url(),
  jwtIssuer: z.string(),
});

export type EmbeddedCustomOauthFormData = z.infer<
  typeof embeddedCustomOauthFormSchema
>;

export const brandEditFormSchema = z.object({
  analyticsKey: z
    .string()
    .regex(
      /^[a-z0-9-_]+$/,
      'Must contain only lowercase alphanumeric characters, dashes, or underscores',
    )
    .nullish(),
  communityDomain: z
    .string()
    .regex(
      /^[a-z0-9.-]+(:[0-9]+)?$/,
      'Must contain only domain e.g. community.brandfeed.ai',
    ),
  customAuthUrl: z.string().url().nullish().or(z.literal('')),
  customLogoutUrl: z.string().url().nullish().or(z.literal('')),
  customOauth: embeddedCustomOauthFormSchema.nullish(),
  customUserSettingsUrl: z.string().url().nullish().or(z.literal('')),
  isPhoneVerificationEnabled: z.boolean().nullish(),
  isRestricted: z.boolean().nullish(),
  isTrial: z.boolean().nullish(),
  name: z.string(),
  shopUrl: z.string().nullish(),
  shouldShowPWA: z.boolean().default(false),
  trialEndsAt: z.string().nullish(),
  usesCustomAuth: z.boolean(),
  usesShopifyEmbedAuth: z.boolean().default(false),
  shopifyHmacSecret: z.string().nullish().or(z.literal('')),
});

export type BrandFormData = z.infer<typeof brandEditFormSchema>;
